import { render, staticRenderFns } from "./page-agv-customer-transactions-list.vue?vue&type=template&id=af9f8d4e&scoped=true&lang=pug&"
import script from "./page-agv-customer-transactions-list.vue?vue&type=script&lang=js&"
export * from "./page-agv-customer-transactions-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9f8d4e",
  null
  
)

export default component.exports